import React from 'react';
import { Map } from 'react-map-gl/mapbox';

interface MapGLProps {
  longitude: number;
  latitude: number;
  zoom: number;
  pitch: number;
  bearing: number;
  width: number;
  height: number;
  maxZoom?: number;
  mapStyle: string;
  mapboxApiAccessToken: string;
  children?: React.ReactNode;
}

const NO_PADDING = { top: 0, bottom: 0, left: 0, right: 0 };

export const MapGL: React.FC<MapGLProps> = ({
  longitude,
  latitude,
  zoom,
  pitch,
  bearing,
  width,
  height,
  maxZoom,
  mapStyle,
  mapboxApiAccessToken,
  children,
}) => {
  return (
    <Map
      interactive={false}
      mapboxAccessToken={mapboxApiAccessToken}
      mapStyle={mapStyle}
      maxZoom={maxZoom}
      style={{ width, height }}
      viewState={{ longitude, latitude, zoom, pitch, bearing, padding: NO_PADDING, width, height }}>
      {children}
    </Map>
  );
};
